// extracted by mini-css-extract-plugin
export default {"share-pcf-button":"SharePcfButton_share-pcf-button__y9det"};